import script from "./ManageAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAuth.vue?vue&type=script&setup=true&lang=js"

import "./ManageAuth.vue?vue&type=style&index=0&id=d42aeb18&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42aeb18"]])

export default __exports__